export default "__VITE_ASSET__DRgyReAf__"